import Vue from "vue";
import Router from "vue-router";
import Home from "./pages/Home.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import Loesungen from "./pages/Loesungen.vue";
import ContactUs from "./pages/ContactUs.vue";
import Pricing from "./pages/Pricing.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/Home"
    },
    {
      path: "/Home",
      name: "Home",
      components: {default: Home, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    },
    {
      path: "/contact",
      name: "contact",
      components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
      props: {footer: {backgroundColor: 'black'}}
    },
    {
      path: "/pricing",
      name: "pricing",
      components: {default: Pricing, header: MainNavbar, footer: MainFooter}
    },
    {
      path: "/loesungen",
      name: "loesungen",
      components: {default: Loesungen, header: MainNavbar}
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});

export default router;
